<template>
  <div
    class="tags"
    v-if="tags && tags.length > 0"
  >
    <span
      v-for="(tag, index) in tags"
      :key="index"
      class="tag"
      :class="cssClass"
    >
      <span class="tag-text">{{ tag }}</span>
      <a
        v-if="showDelete"
        @click="removeTag(tag, index)"
        class="delete is-small"
      ></a>
    </span>
    <span
      class="tag"
      :class="cssClass"
      v-if="remainingTags > 0"
    >
      + {{remainingTags}} tags
    </span>
  </div>
</template>

<script>
export default {
  props: {
    showDelete: {
      default: false,
      type: Boolean
    },
    remainingTags: {
      default: 0,
      type: Number
    },

    tags: {
      default: function() {
        return []
      },
      type: Array
    },

    cssClass: {
      default: 'is-info is-light',
      type: String
    }
  },

  data() {
    return {
      //mTags: this.tags,
    }
  },

  methods: {
    removeTag(tag, index) {
      this.$emit('tagDeleted', tag)
    }
  }
}
</script>

<style lang="scss" scoped>
.tags {
  align-items: flex-start;

  .tag {
    min-height: 2em;
    height: auto;
    padding-top: 0.35em;
    padding-bottom: 0.35em;
    line-height: 1.35;

    .tag-text {
      display: inline-block;
      max-width: 260px;
      white-space: normal;
      word-break: break-word;
      overflow-wrap: break-word;
    }
  }
}
</style>
